const slugToText = (str) => {
  const text = str?.replace(/-/g, " ");
  const string = (text?.charAt(0).toUpperCase() ?? '') + (text?.slice(1) ?? '');

  return string;
}

export default slugToText;
